import * as createjs from 'createjs-module';

export class TrimCjGraphics extends createjs.Graphics {
  constructor() {
    super();
  }
}
